import { getLuminance, transparentize } from 'polished';
import { COR_BRANCA, COR_TEXTO } from './nps.constants';
// Acima deste valor de luminância a cor é considerada clara e recebe texto escuro (D1).
var LIMITE_LUMINANCIA_COR_CLARA = 0.4;
export var grupoDaNota = function (valor) {
    if (valor >= 9)
        return 'promotor';
    if (valor >= 7)
        return 'neutro';
    return 'detrator';
};
export var ehCorClara = function (cor) {
    try {
        return getLuminance(cor) > LIMITE_LUMINANCIA_COR_CLARA;
    }
    catch (_a) {
        // Cor inválida é tratada como escura, sem quebrar a tela (RF-47).
        return false;
    }
};
// Texto e ícones sobre a cor da empresa.
export var corTextoSobre = function (cor) { return (ehCorClara(cor) ? COR_TEXTO : COR_BRANCA); };
// Texto na cor da empresa sobre fundo branco; cor clara demais vira texto escuro (DT-05).
export var corTintaSobreBranco = function (cor) {
    try {
        return getLuminance(cor) > LIMITE_LUMINANCIA_COR_CLARA ? COR_TEXTO : cor;
    }
    catch (_a) {
        // Cor inválida não pode chegar ao CSS: usa o texto padrão (RF-47).
        return COR_TEXTO;
    }
};
export var corComTransparencia = function (cor, opacidade) {
    try {
        return transparentize(1 - opacidade, cor);
    }
    catch (_a) {
        return transparentize(1 - opacidade, COR_BRANCA);
    }
};
export var primeiroNome = function (nome) { return (nome || '').trim().split(/\s+/)[0] || ''; };
// Sem nome da empresa cadastrado, troca "a equipe da [cliente]" por "a nossa equipe" para não deixar lacuna.
var TEXTOS_OBRIGADO_SEM_NOME = {
    detratorComContato: 'Recebemos seu contato. A nossa equipe vai falar com você em breve.',
    detratorSemContato: 'Obrigado pela sinceridade! Sua opinião chegou para a nossa equipe e vai nos ajudar a melhorar.',
    neutro: 'Sua opinião nos ajuda a chegar no 10.',
    promotor: 'Sua opinião já chegou para a nossa equipe.',
};
export var textoObrigado = function (cenario, cliente) {
    if (!(cliente === null || cliente === void 0 ? void 0 : cliente.trim()))
        return TEXTOS_OBRIGADO_SEM_NOME[cenario];
    var textos = {
        detratorComContato: "Recebemos seu contato. A equipe da " + cliente + " vai falar com voc\u00EA em breve.",
        detratorSemContato: "Obrigado pela sinceridade! Sua opini\u00E3o chegou para a equipe da " + cliente + " e vai nos ajudar a melhorar.",
        neutro: "Sua opini\u00E3o ajuda a " + cliente + " a chegar no 10.",
        promotor: "Sua opini\u00E3o j\u00E1 chegou para a equipe da " + cliente + ".",
    };
    return textos[cenario];
};
var copiarComExecCommand = function (texto) {
    var area = document.createElement('textarea');
    area.value = texto;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    area.style.opacity = '0';
    document.body.appendChild(area);
    try {
        area.focus();
        area.select();
        area.setSelectionRange(0, texto.length);
        // execCommand está depreciado, mas é o único que o Safari do iPhone aceita dentro do toque (bug 4921).
        return document.execCommand('copy');
    }
    catch (_a) {
        return false;
    }
    finally {
        document.body.removeChild(area);
    }
};
// Precisa ser chamada dentro do clique: primeiro execCommand (síncrono), depois navigator.clipboard (DT-06).
export var copiarTexto = function (texto) {
    var _a;
    if (copiarComExecCommand(texto))
        return Promise.resolve(true);
    if (!((_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText))
        return Promise.resolve(false);
    return navigator.clipboard
        .writeText(texto)
        .then(function () { return true; })
        .catch(function () { return false; });
};
